module.exports = __webpack_public_path__ + "24c11b98899bac00923118d9ed47a4fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/flower-pink.png
// module id = 2191
// module chunks = 0